<script setup>
  defineProps({
    size: {
      type: [String, Number],
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    viewBox: {
      type: String,
      default: '0 0 24 24'
    }
  })
</script>

<template>
  <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
       width="48" height="48" :fill="color">
    <path
        d="M426.666667 213.333333H341.333333v85.333334h85.333334V213.333333zM426.666667 469.333333H341.333333v85.333334h85.333334v-85.333334zM341.333333 725.333333h85.333334v85.333334H341.333333v-85.333334zM682.666667 213.333333h-85.333334v85.333334h85.333334V213.333333zM597.333333 469.333333h85.333334v85.333334h-85.333334v-85.333334zM682.666667 725.333333h-85.333334v85.333334h85.333334v-85.333334z"
    ></path>
  </svg>
</template>

<style scoped>

</style>